import { createResource } from '@atlassian/react-resource-router';
import type { PreferenceOptions, UserPreferences } from './types.tsx';
import {
	DEFAULT_EDITOR_PREFERENCE_KEY,
	WORKFLOW_EDITOR_PREFERENCES_KEY,
	CHANGEBOARDING_DISMISSED_PREFERENCE_KEY,
} from './constants.tsx';

import { getUserPreferences } from './services/get-user-preferences/index.tsx';
import { useUserPreference } from './hooks/index.tsx';

const workflowEditorPreferenceKeys = [
	DEFAULT_EDITOR_PREFERENCE_KEY,
	CHANGEBOARDING_DISMISSED_PREFERENCE_KEY,
] as const;

export const workflowEditorPreferencesResource = createResource<UserPreferences>({
	type: WORKFLOW_EDITOR_PREFERENCES_KEY,
	getKey: () => WORKFLOW_EDITOR_PREFERENCES_KEY,
	getData: () => getUserPreferences([...workflowEditorPreferenceKeys]),
	maxAge: 1000,
	isBrowserOnly: true,
});

type WorkflowEditorPreferenceKey = (typeof workflowEditorPreferenceKeys)[number];

export const useWorkflowEditorPreference = (
	key: WorkflowEditorPreferenceKey,
	options?: PreferenceOptions,
) => useUserPreference(workflowEditorPreferencesResource, key, options);
